import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import "./CSS/Role_Management.css"
import Store from "../Store/Store.js"
import { set_user_item, set_yetkilendirme_state } from "../Action/Action.js"
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min.js'

const Role_Management = (props) => {


    const history = useHistory();



    const [userList, Set_userList] = useState([])


    const [selected_users, Set_selected_users] = useState([])


    const [user_detail, Set_user_detail_] = useState([])



    const [see_user_detail, Set_see_user_detail] = useState(false)
    const [group_detail, Set_group_detail] = useState({})

    //yetkilendirme
    const [user_yazma_control, Set_user_yazma_control] = useState(false);

    const [inital_company_select_control, Set_inital_company_select_control] = useState(true)

    // SCADA Pages state
    const [scadaPages, Set_scadaPages] = useState([])

    // Company selection state (moved here to be available for useEffects)
    const [createUserCID, Set_createUserCID] = useState("")

    // User's companyId from sessionStorage for SCADA visibility
    const userCompanyId = Number(sessionStorage.getItem("user_companyId")) || 0;

    useEffect(() => {
        const fetchUserList = async () => {
            const companyId = createUserCID || props.temp_com_id || props.com_id;
            if (!companyId) return;

            try {
                const req__ = await fetch(
                    "https://app-rmmsapi.azurewebsites.net/api/person/GetUserList",
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        method: "POST",
                        body: JSON.stringify({
                            companyId: String(companyId),
                        }),
                    }
                );

                const response__ = await req__.json();

                if (req__.status === 200 && response__.length > 0) {
                    Store.dispatch(set_user_item(response__));
                    Set_userList(response__);
                }
            } catch (err) {
                console.log(err);
            }
        }
        fetchUserList();
    }, [createUserCID, props.temp_com_id, props.com_id])

    // Fetch SCADA pages when company changes
    useEffect(() => {
        const fetchScadaPages = async () => {
            try {
                const companyId = createUserCID || props.temp_com_id || props.com_id;
                if (!companyId) return;

                const response = await fetch(
                    `https://app-rmmsapi.azurewebsites.net/api/scada/pages?companyId=${companyId}`,
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        method: "GET",
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    // Filter only active pages
                    const activePages = data.filter(p => p.isActive);
                    Set_scadaPages(activePages);
                    console.log("SCADA Pages loaded:", activePages);
                }
            } catch (err) {
                console.log("Error fetching SCADA pages:", err);
            }
        };
        fetchScadaPages();
    }, [createUserCID, props.temp_com_id, props.com_id])

    useEffect(() => {

        props.users_list.forEach(x => {

            if (x.userId === props.uid && x.yetkilendirme) {
                console.log(x);
                let yetki_parse = JSON.parse(x.yetkilendirme)

                if (yetki_parse[props.temp_com_id < 3 ? 2 : props.temp_com_id]["Kullanıcı Paneli"]["Y"] === "t") {

                    Set_user_yazma_control(true)
                } else {
                    Set_user_yazma_control(false)
                }


            }
        })
    }, [props.yetkilendirme])

    useEffect(() => { console.warn(props.temp_com_id, "tempcomid") }, [props.temp_com_id])



    useEffect(() => {
        console.log(props.userList);
        Set_userList(props.users_list)
    }, [props.users_list])

    useEffect(() => {
        console.log(user_detail);
        if (JSON.stringify(user_detail) !== "[]") {


            let data = []
            let newdata = selected_users;
            userList.forEach(x => {
                newdata.forEach(a => {
                    console.log(a, x);
                    if (x.userId === a) {
                        data.push(x)
                    }

                })
            })
            console.log(data);
            Set_user_detail_(data)
        }

    }, [user_detail])

    const yetkilendirmeObjesi = {
        // SCADA Pages - dinamik olarak eklenir
        ...scadaPages.reduce((acc, item) => {
            acc[item.pageName] = { O: "f", Y: "f", S: "f" };
            return acc;
        }, {}),
        // Sabit menü öğeleri
        "Kullanıcı Paneli": { O: "f", Y: "f", S: "f" },
        "İletişim": { O: "f", Y: "f", S: "f" },
        "Raporlama": { O: "f", Y: "f", S: "f" },
        "Misafir-Oda": { O: "f", Y: "f", S: "f" },
        "Page_Management": { O: "f", Y: "f", S: "f" },
        "Template_Management": { O: "f", Y: "f", S: "f" },
        "Program": { O: "f", Y: "f", S: "f" },
        "Alarm": { O: "f", Y: "f", S: "f" },
        "Dashboard": { O: "f", Y: "f", S: "f" },
        "SCADA_Sistemi": { O: "f", Y: "f", S: "f" }
    };

    const [yetkilendirme, Set_yetkilendirme] = useState(yetkilendirmeObjesi)


    const onChangeinp1 = (e) => {

        let yetki_name = e.target.parentElement.parentElement.firstElementChild.textContent;
        if (yetki_name === "Sayfa Yönetimi") {
            yetki_name = "Page_Management"
        } else if (yetki_name === "Widget Yönetimi") {
            yetki_name = "Template_Management"
        }


        let obj_prev = yetkilendirme

        let name_list = [];

        // SCADA pages için default yetki kontrolü
        scadaPages.forEach((page) => {
            const hasAccess = obj_prev[page.pageName];
            if (!hasAccess) {
                name_list.push(page.pageName);
            }
        });

        // Alarm kontrolü
        if (!obj_prev["Alarm"]) {
            name_list.push("Alarm");
        }

        // Erişimi olmayan sayfalara default yetki ata
        name_list.forEach((name) => {
            obj_prev[name] = { "O": "f", "Y": "f", "S": "f" };
        });

        if (e.target.checked) {
            obj_prev[yetki_name]["O"] = "t"
        } else {
            obj_prev[yetki_name]["O"] = "f"
        }

        Set_yetkilendirme(obj_prev)

    }
    const onChangeinp2 = (e) => {
        let yetki_name = e.target.parentElement.parentElement.firstElementChild.textContent;
        if (yetki_name === "Sayfa Yönetimi") {
            yetki_name = "Page_Management"
        } else if (yetki_name === "Widget Yönetimi") {
            yetki_name = "Template_Management"
        }
        let obj_prev = yetkilendirme;

        let name_list = [];

        // SCADA pages için default yetki kontrolü
        scadaPages.forEach((page) => {
            const hasAccess = obj_prev[page.pageName];
            if (!hasAccess) {
                name_list.push(page.pageName);
            }
        });

        // Alarm kontrolü
        if (!obj_prev["Alarm"]) {
            name_list.push("Alarm");
        }

        // Erişimi olmayan sayfalara default yetki ata
        name_list.forEach((name) => {
            obj_prev[name] = { "O": "f", "Y": "f", "S": "f" };
        });

        if (e.target.checked) {
            obj_prev[yetki_name]["Y"] = "t"
        } else {
            obj_prev[yetki_name]["Y"] = "f"
        }

        Set_yetkilendirme(obj_prev)
    }
    const onChangeinp3 = (e) => {
        let yetki_name = e.target.parentElement.parentElement.firstElementChild.textContent;
        if (yetki_name === "Sayfa Yönetimi") {
            yetki_name = "Page_Management"
        } else if (yetki_name === "Widget Yönetimi") {
            yetki_name = "Template_Management"
        }
        let obj_prev = yetkilendirme;

        let name_list = [];

        // SCADA pages için default yetki kontrolü
        scadaPages.forEach((page) => {
            const hasAccess = obj_prev[page.pageName];
            if (!hasAccess) {
                name_list.push(page.pageName);
            }
        });

        // Alarm kontrolü
        if (!obj_prev["Alarm"]) {
            name_list.push("Alarm");
        }

        // Erişimi olmayan sayfalara default yetki ata
        name_list.forEach((name) => {
            obj_prev[name] = { "O": "f", "Y": "f", "S": "f" };
        });



        if (e.target.checked) {
            obj_prev[yetki_name]["S"] = "t"
        } else {
            obj_prev[yetki_name]["S"] = "f"

        }

        Set_yetkilendirme(obj_prev)
    }

    const saveToDBFunc = async (e) => {
        e.preventDefault();

        let last_obj;
        let idc = props.temp_com_id < 3 ? "2" : props.temp_com_id;



        try {
            for (let i of selected_users) {
                let old_yetki = null;
                props.users_list.forEach(a => {
                    if (a.userId === i && a.yetkilendirme) {
                        old_yetki = JSON.parse(a.yetkilendirme)
                    }
                })

                old_yetki = old_yetki ? old_yetki : null;

                let updated_yetki = old_yetki
                    ? {
                        ...old_yetki,
                        [idc]: {
                            ...(old_yetki[idc] || {}),
                            ...yetkilendirme
                        }
                    }
                    : { [idc]: { ...yetkilendirme } }; // Eğer old_yetki null ise, direkt yeni yetkilendirmeyi ata


                let yetki_datas_string = JSON.stringify(updated_yetki);
                console.warn("warn", yetki_datas_string);
                const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/person/SetYetkilendirme", {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    },
                    method: "POST",
                    body: JSON.stringify({
                        yetkilendirme: yetki_datas_string,
                        userId: i
                    })
                })
                const response = await request.json();

                if (request.status === 200) {
                    let obj = { [i]: JSON.parse(response[0]).yetkilendirme }

                    Store.dispatch(set_yetkilendirme_state(obj))
                }
            }


        } catch (err) {
            console.log(err);
        } finally {
            Set_selected_users([]);
            const yetkilendirmeObjesi = {
                // SCADA Pages - dinamik
                ...scadaPages.reduce((acc, item) => {
                    acc[item.pageName] = { O: "f", Y: "f", S: "f" };
                    return acc;
                }, {}),
                // Sabit menü öğeleri
                "Kullanıcı Paneli": { O: "f", Y: "f", S: "f" },
                "İletişim": { O: "f", Y: "f", S: "f" },
                "Raporlama": { O: "f", Y: "f", S: "f" },
                "Misafir-Oda": { O: "f", Y: "f", S: "f" },
                "Page_Management": { O: "f", Y: "f", S: "f" },
                "Template_Management": { O: "f", Y: "f", S: "f" },
                "Program": { O: "f", Y: "f", S: "f" },
                "Alarm": { O: "f", Y: "f", S: "f" },
                "Dashboard": { O: "f", Y: "f", S: "f" },
                "SCADA_Sistemi": { O: "f", Y: "f", S: "f" }
            };
            Set_yetkilendirme(yetkilendirmeObjesi)
            document.querySelectorAll(".unselected-li-active").forEach(x => {
                x.classList.remove("unselected-li-active")
            });

            history.push("/")

            window.location.reload();

        }

    }

    const isCheckedFunc = (isim, type) => {
        let userID = selected_users[0];
        let yetki_parse;
        userList.forEach(x => {

            if (x.userId === userID && x.yetkilendirme) {
                yetki_parse = JSON.parse(x.yetkilendirme)
            }
        })

        if (yetki_parse && yetki_parse[props.temp_com_id < 3 ? "2" : props.temp_com_id] && yetki_parse[props.temp_com_id < 3 ? "2" : props.temp_com_id][isim] && yetki_parse[props.temp_com_id < 3 ? "2" : props.temp_com_id][isim][type] === "t") {
            return true
        } else {
            return false
        }

    }

    useEffect(() => {
        console.log(selected_users);
        let userID = selected_users[0];
        let yetki_parse;
        props.users_list.forEach(x => {

            if (x.userId === userID && x.yetkilendirme) {
                yetki_parse = JSON.parse(x.yetkilendirme)
                console.log(yetki_parse[2]);
                let com_id = String(props.temp_com_id || 2);

                Set_yetkilendirme(yetki_parse[com_id])
                const yetkiObj = yetki_parse?.[com_id];
                if (yetkiObj && typeof yetkiObj === "object") {
                    Object.entries(yetkiObj).forEach(s => {
                        let isim = s[0]
                        Object.entries(s[1]).forEach(a => {
                            isCheckedFunc(isim, a[0])
                        })
                    })
                }
            }
        })





    }, [selected_users])

    useEffect(() => { console.log(inital_company_select_control);}, [inital_company_select_control])

    const [createUserCID2, Set_createUserCID2] = useState("")


    useEffect(() => {
        if (inital_company_select_control) {
            if (createUserCID !== "") {
                let data = props.users_list;
                let newData = [];
                data.forEach(x => {
                    if (x.companyId === createUserCID) {
                        newData.push(x)
                    }
                })

                Set_userList(newData);
                if (createUserCID2 !== "") {
                    Set_inital_company_select_control(false)
                }
            }
        } else {
            if (createUserCID !== "") {
                let data = props.users_list;
                let newData = [];
                data.forEach(x => {
                    if (x.companyId === createUserCID) {
                        newData.push(x)
                    }
                })

                Set_userList(newData);
            }
        }


    }, [createUserCID, createUserCID2])


    const [isOpen, setIsOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState('Şirket Seçin');

    useEffect(() => { Set_createUserCID(props.com_id) }, [props.com_id])

    // Auto-set selectedItem based on current company
    useEffect(() => {
        const companyNames = {
            1: 'Akra V',
            2: 'RMMS',
            3: 'Crowne Plaza Harbiye',
            4: 'Akra Antalya'
        };
        if (props.temp_com_id && companyNames[props.temp_com_id]) {
            setSelectedItem(companyNames[props.temp_com_id]);
        }
    }, [props.temp_com_id])

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        if (props.com_id !== "1") {
            console.log(props.com_id);
            Set_inital_company_select_control(false)
        }
    }, [props.com_id])

    const handleItemClick = (event) => {
        Set_selected_users([])
        let id_ = event.target.id;
        if (id_ && id_ !== undefined && id_ !== null) {
            Set_createUserCID(id_)
            Set_createUserCID2(id_)

        }

        setSelectedItem(event.target.textContent);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.dropdownx')) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <seciton className="section_user_management">
            {!inital_company_select_control && <>
                <div style={{
                    display: "flex", alignItems: "center", justifyContent: "left", position: "relative",
                    left: "22%", top: "-12px"
                }} className="top">

                    {props.ucer_id === 1 && <div style={{ width: "10%" }} className="dropdownx">
                        <button style={{ maxWidth: "20%", fontWeight: "600", borderColor: "rgb(237,188,69)" }} className="dropdownx-button" onClick={toggleDropdown}>
                            {selectedItem}
                        </button>
                        {isOpen && (
                            <div style={{ maxWidth: "20%" }} className="dropdownx-content">
                                {props.companies_list && props.companies_list.length > 0 && props.companies_list.map((item, index) => {
                                    return <span id={item.companyID} key={item.companyID} data-value={item.companyID} onClick={handleItemClick}>{item.companyName}</span>

                                })}

                            </div>
                        )}
                    </div>}
                </div>

                <div className="bottom">
                    <div className="left">

                        {see_user_detail &&
                            <div className="add_group_area">
                                <i onClick={() => {
                                    Set_see_user_detail(false)
                                    Set_user_detail_({})
                                }} style={{ position: "relative", left: "48%", color: "brown", scale: "1.3", cursor: "pointer" }} className="fa fa-arrow-left"></i>
                                <div className='displayflexdiv'>
                                    <div style={{ width: "100%" }} className="lefcx">
                                        <label htmlFor="name">Kullanıcı İsmi-Soyismi</label>

                                        <input style={{ marginBottom: "12px" }} value={user_detail.name} type="text" className="add_user_name_inp" />
                                        <label htmlFor="email">Email</label>
                                        <input style={{ marginBottom: "12px" }} value={user_detail.email} type="email" className="add_user_email_inp" />

                                        <label htmlFor="desc">Parola</label>
                                        <input style={{ marginBottom: "12px" }} type='password' value={user_detail.pwd} className="add_user_name_inp" />


                                        <div style={{ marginTop: "6%" }} className="uuid_part_view_u_detail"><span style={{ color: "rgb(80,80,80)" }}>User ID:</span> {user_detail.userId}</div>


                                    </div>

                                </div>
                            </div>}

                        {see_user_detail === false && <div className="group_list">

                            <h2>Kullanıcılar</h2>
                            <ul className='group_ul_list'>
                                {selectedItem !== "Şirket Seçin" && userList.length > 0 ? userList.map((item, index) => {
                                    console.log(userList);
                                    return <li className='unselected-li' id={"g" + item.userId} onClick={(e) => {

                                        let div_ = document.querySelector(`#g${item.userId}`)
                                        document.querySelectorAll(".unselected-li-active").forEach(s => {
                                            if (s !== div_) s.classList.remove("unselected-li-active");
                                        })
                                        if (!div_.classList.contains("unselected-li-active")) {
                                            Set_selected_users([])

                                            setTimeout(() => {
                                                let data_ = [];
                                                data_.push(item.userId)
                                                console.log(data_);
                                                Set_selected_users(data_)
                                                div_.classList.toggle("unselected-li-active");
                                            }, 1)


                                        } else {
                                            div_.classList.toggle("unselected-li-active");

                                            Set_selected_users([])

                                        }
                                    }}><div style={{ width: "60%" }}><i style={{ marginRight: "4%" }} class="fa-solid fa-user"></i> {item.userName}</div> {!user_yazma_control || <p onClick={() => {
                                        Set_see_user_detail(true)
                                        Set_user_detail_({ name: item.userName, email: item.email })
                                    }} style={{ fontWeight: "700", color: "rgba(237,188,69,0.8)", cursor: "pointer" }}>Detayları Gör <i className="fa fa-arrow-right"></i></p>}</li>
                                }) : <p style={{ position: "relative", transform: "translate(55%,40%)" }} className='empty_info_kullanıcı'>Kayıtlı Hiç Kullanıcı Yok</p>}
                            </ul>

                        </div>}

                    </div>

                    <div style={{ width: "40%" }} className="right">
                        {selected_users.length > 0 &&
                            <div style={{ position: "relative" }} className="group_list">

                                <h2 style={{ marginTop: "1%" }}>Yetkilendirme</h2>
                                {(Number(createUserCID) || Number(props.temp_com_id)) !== 1 ? ((Number(createUserCID) || Number(props.temp_com_id)) < 3 ? <div className='displayflexdiv role_management_displafl'>
                                    <div className="first_row row"><div className="div1">İsim</div> <div className="div2"><span>Okuma</span><span>Yazma</span><span>Silme</span></div></div>

                                    <div className="row"><div className="div1">VRF</div><div className="div2"><input defaultChecked={isCheckedFunc("VRF", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input defaultChecked={isCheckedFunc("VRF", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input defaultChecked={isCheckedFunc("VRF", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                    <div className="row">
                                        <div className="div1">Sıcak Su</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Sıcak Su", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Sıcak Su", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Sıcak Su", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Fanlar</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Fanlar", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Fanlar", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Fanlar", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Su Depoları</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Su Depoları", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Su Depoları", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Su Depoları", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Enerji İzleme</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Enerji İzleme", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Enerji İzleme", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Enerji İzleme", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Pompa/Hidrofor</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Pompa/Hidrofor", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Pompa/Hidrofor", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Pompa/Hidrofor", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>



                                    <div className="row">
                                        <div className="div1">İletişim</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("İletişim", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("İletişim", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("İletişim", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Kullanıcı Paneli</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Kullanıcı Paneli", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Kullanıcı Paneli", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Kullanıcı Paneli", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Raporlama</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Raporlama", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Raporlama", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Raporlama", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Misafir-Oda</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Misafir-Oda", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Misafir-Oda", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Misafir-Oda", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Sayfa Yönetimi</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Page_Management", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Page_Management", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Page_Management", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Widget Yönetimi</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Template_Management", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Template_Management", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Template_Management", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Program</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Program", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Program", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Program", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Alarm</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Alarm", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Alarm", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Alarm", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Dashboard</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Dashboard", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Dashboard", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Dashboard", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    {(userCompanyId === 2 || Number(createUserCID) === 2 || Number(props.temp_com_id) === 2) && (
                                    <div className="row">
                                        <div className="div1">SCADA Sistemi</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("SCADA_Sistemi", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("SCADA_Sistemi", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("SCADA_Sistemi", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    )}
                                </div> : <div className='displayflexdiv role_management_displafl'>
                                    <div className="first_row row"><div className="div1">İsim</div> <div className="div2"><span>Okuma</span><span>Yazma</span><span>Silme</span></div></div>



                                    {scadaPages.map((item, index) => {
                                        return <div className="row" key={index}>
                                            <div className="div1">{item.pageName}</div>
                                            <div className="div2">
                                                <input defaultChecked={isCheckedFunc(item.pageName, "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                                <input defaultChecked={isCheckedFunc(item.pageName, "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                                <input defaultChecked={isCheckedFunc(item.pageName, "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                            </div>
                                        </div>
                                    })}

                                    <div className="row">
                                        <div className="div1">İletişim</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("İletişim", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("İletişim", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("İletişim", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Kullanıcı Paneli</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Kullanıcı Paneli", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Kullanıcı Paneli", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Kullanıcı Paneli", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Raporlama</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Raporlama", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Raporlama", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Raporlama", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Misafir-Oda</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Misafir-Oda", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Misafir-Oda", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Misafir-Oda", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Sayfa Yönetimi</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Page_Management", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Page_Management", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Page_Management", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Widget Yönetimi</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Template_Management", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Template_Management", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Template_Management", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Program</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Program", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Program", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Program", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Alarm</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Alarm", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Alarm", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Alarm", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Dashboard</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Dashboard", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Dashboard", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Dashboard", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    {(userCompanyId === 2 || Number(createUserCID) === 2 || Number(props.temp_com_id) === 2) && (
                                    <div className="row">
                                        <div className="div1">SCADA Sistemi</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("SCADA_Sistemi", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("SCADA_Sistemi", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("SCADA_Sistemi", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    )}
                                </div>) : (props.temp_com_id < 3 ? <div className='displayflexdiv role_management_displafl'>
                                    <div className="first_row row"><div className="div1">İsim</div> <div className="div2"><span>Okuma</span><span>Yazma</span><span>Silme</span></div></div>

                                    <div className="row"><div className="div1">VRF</div><div className="div2"><input defaultChecked={isCheckedFunc("VRF", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input defaultChecked={isCheckedFunc("VRF", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input defaultChecked={isCheckedFunc("VRF", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                    <div className="row">
                                        <div className="div1">Sıcak Su</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Sıcak Su", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Sıcak Su", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Sıcak Su", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Fanlar</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Fanlar", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Fanlar", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Fanlar", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Su Depoları</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Su Depoları", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Su Depoları", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Su Depoları", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Enerji İzleme</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Enerji İzleme", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Enerji İzleme", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Enerji İzleme", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Pompa/Hidrofor</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Pompa/Hidrofor", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Pompa/Hidrofor", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Pompa/Hidrofor", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>



                                    <div className="row">
                                        <div className="div1">İletişim</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("İletişim", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("İletişim", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("İletişim", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Kullanıcı Paneli</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Kullanıcı Paneli", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Kullanıcı Paneli", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Kullanıcı Paneli", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Raporlama</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Raporlama", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Raporlama", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Raporlama", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Misafir-Oda</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Misafir-Oda", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Misafir-Oda", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Misafir-Oda", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Sayfa Yönetimi</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Page_Management", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Page_Management", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Page_Management", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Widget Yönetimi</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Template_Management", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Template_Management", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Template_Management", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Program</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Program", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Program", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Program", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Alarm</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Alarm", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Alarm", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Alarm", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Dashboard</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Dashboard", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Dashboard", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Dashboard", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    {(userCompanyId === 2 || Number(createUserCID) === 2 || Number(props.temp_com_id) === 2) && (
                                    <div className="row">
                                        <div className="div1">SCADA Sistemi</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("SCADA_Sistemi", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("SCADA_Sistemi", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("SCADA_Sistemi", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    )}
                                </div> : <div className='displayflexdiv role_management_displafl'>
                                    <div className="first_row row"><div className="div1">İsim</div> <div className="div2"><span>Okuma</span><span>Yazma</span><span>Silme</span></div></div>



                                    {scadaPages.map((item, index) => {
                                        return <div className="row" key={index}>
                                            <div className="div1">{item.pageName}</div>
                                            <div className="div2">
                                                <input defaultChecked={isCheckedFunc(item.pageName, "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                                <input defaultChecked={isCheckedFunc(item.pageName, "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                                <input defaultChecked={isCheckedFunc(item.pageName, "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                            </div>
                                        </div>
                                    })}

                                    <div className="row">
                                        <div className="div1">İletişim</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("İletişim", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("İletişim", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("İletişim", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Kullanıcı Paneli</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Kullanıcı Paneli", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Kullanıcı Paneli", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Kullanıcı Paneli", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Raporlama</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Raporlama", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Raporlama", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Raporlama", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Misafir-Oda</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Misafir-Oda", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Misafir-Oda", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Misafir-Oda", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Sayfa Yönetimi</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Page_Management", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Page_Management", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Page_Management", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Widget Yönetimi</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Template_Management", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Template_Management", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Template_Management", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Program</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Program", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Program", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Program", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Alarm</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Alarm", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Alarm", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Alarm", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="div1">Dashboard</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("Dashboard", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("Dashboard", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("Dashboard", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    {(userCompanyId === 2 || Number(createUserCID) === 2 || Number(props.temp_com_id) === 2) && (
                                    <div className="row">
                                        <div className="div1">SCADA Sistemi</div>
                                        <div className="div2">
                                            <input defaultChecked={isCheckedFunc("SCADA_Sistemi", "O")} onChange={onChangeinp1} type="checkbox" name="" id="okuma" />
                                            <input defaultChecked={isCheckedFunc("SCADA_Sistemi", "Y")} onChange={onChangeinp2} type="checkbox" name="" id="yazma" />
                                            <input defaultChecked={isCheckedFunc("SCADA_Sistemi", "S")} onChange={onChangeinp3} type="checkbox" name="" id="silme" />
                                        </div>
                                    </div>
                                    )}
                                </div>)}

                                <div className="btn_group">
                                    <button onClick={saveToDBFunc} className="save_yetkilendirme">Kaydet</button>
                                    <button onClick={() => {
                                        const yetkilendirmeObjesi = {
                                            ...scadaPages.reduce((acc, item) => {
                                                acc[item.pageName] = { O: "f", Y: "f", S: "f" };
                                                return acc;
                                            }, {}),
                                            "Kullanıcı Paneli": { O: "f", Y: "f", S: "f" },
                                            "İletişim": { O: "f", Y: "f", S: "f" },
                                            "Raporlama": { O: "f", Y: "f", S: "f" },
                                            "Misafir-Oda": { O: "f", Y: "f", S: "f" },
                                            "Page_Management": { O: "f", Y: "f", S: "f" },
                                            "Template_Management": { O: "f", Y: "f", S: "f" },
                                            "Program": { O: "f", Y: "f", S: "f" },
                                            "Alarm": { O: "f", Y: "f", S: "f" },
                                            "Dashboard": { O: "f", Y: "f", S: "f" },
                                            "SCADA_Sistemi": { O: "f", Y: "f", S: "f" }
                                        };
                                        Set_yetkilendirme(yetkilendirmeObjesi)
                                        var emptyarr = []
                                        Set_selected_users(emptyarr);
                                        document.querySelectorAll(".unselected-li-active").forEach(x => {
                                            x.classList.remove("unselected-li-active")
                                        })
                                    }} className="save_yetkilendirme_iptal">İptal</button>

                                </div>



                            </div>
                        }
                        {selected_users.length < 1 &&
                            <>
                                <p className='alert_choose_group_text'>{user_yazma_control ? "Öncelikle kişi seçiniz" : "Buna yetkiniz yok!"}</p>

                                {props.temp_com_id <= 2 ? <div style={{ position: "relative" }} id="blur" className="group_list">

                                    <h2 style={{ marginTop: "1%" }}>Yetkilendirme</h2>
                                    <div className='displayflexdiv role_management_displafl'>
                                        <div className="first_row row"><div className="div1">İsim</div> <div className="div2"><span>Okuma</span><span>Yazma</span><span>Silme</span></div></div>

                                        <div className="row"><div className="div1">VRF</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                        <div className="row"><div className="div1">Sıcak Su</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                        <div className="row"><div className="div1">Fanlar</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                        <div className="row"><div className="div1">Su Depoları</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                        <div className="row"><div className="div1">Enerji İzleme</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                        <div className="row"><div className="div1">Pompa/Hidrofor</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>)


                                        <div className="row"><div className="div1">İletişim</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                        <div className="row"><div className="div1">Kullanıcı Paneli</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                        <div className="row"><div className="div1">Raporlama</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                        <div className="row"><div className="div1">Misafir-Oda</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                        <div className="row"><div className="div1">Sayfa Yönetimi</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                        <div className="row"><div className="div1">Widget Yönetimi</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                        <div className="row"><div className="div1">Program</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>

                                        <div className="row"><div className="div1">Dashboard</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>


                                    </div>



                                </div> :
                                    <div style={{ position: "relative" }} id="blur" className="group_list">

                                        <h2 style={{ marginTop: "1%" }}>Yetkilendirme</h2>
                                        <div className='displayflexdiv role_management_displafl'>
                                            <div className="first_row row"><div className="div1">İsim</div> <div className="div2"><span>Okuma</span><span>Yazma</span><span>Silme</span></div></div>

                                            {scadaPages.map((item, index) => {
                                                return <div className="row" key={index}><div className="div1">{item.pageName}</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                            })}


                                            <div className="row"><div className="div1">İletişim</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                            <div className="row"><div className="div1">Kullanıcı Paneli</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                            <div className="row"><div className="div1">Raporlama</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                            <div className="row"><div className="div1">Misafir-Oda</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                            <div className="row"><div className="div1">Sayfa Yönetimi</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                            <div className="row"><div className="div1">Widget Yönetimi</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>
                                            <div className="row"><div className="div1">Program</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>

                                            <div className="row"><div className="div1">Dashboard</div><div className="div2"><input onChange={onChangeinp1} type="checkbox" name="" id="okuma" /><input onChange={onChangeinp2} type="checkbox" name="" id="yazma" /><input onChange={onChangeinp3} type="checkbox" name="" id="silme" /></div></div>


                                        </div>



                                    </div>}
                            </>}
                    </div>
                </div>
            </>
            }
            {inital_company_select_control && <section className='section_user_management xf_user_section'>

                <div style={{ left: "0%", top: "15%", width: "20%" }} className="dropdownx">
                    <button style={{ maxWidth: "100%", fontWeight: "700", fontSize: "larger", borderColor: "rgb(237,188,69)" }} className="dropdownx-button" onClick={toggleDropdown}>
                        {selectedItem}
                    </button>
                    {isOpen && (
                        <div style={{ maxWidth: "100%" }} className="dropdownx-content">
                            {props.companies_list && props.companies_list.length > 0 && props.companies_list.map((item, index) => {
                                return <span id={item.companyID} key={item.companyID} data-value={item.companyID} onClick={handleItemClick}>{item.companyName}</span>
                            })}

                        </div>
                    )}
                </div>
            </section>}
        </seciton>
    )
}

const MapStateToProps = (state) => {
    return {
        groups: state.project_reducer.groups_list,
        users_list: state.project_reducer.users_list,
        yetkilendirme: state.project_reducer.yetkilendirme_state,
        group_id: state.project_reducer.group_id,
        uid: state.auth_reducer.user_id,
        com_id: state.project_reducer.company_id,
        pages: state.project_reducer.pages,
        ucer_id: state.project_reducer.ucer_id,
        temp_com_id: state.project_reducer.temp_com_id,
        companies_list: state.project_reducer.companies_list

    }
}

export default connect(MapStateToProps)(Role_Management)